import { render, staticRenderFns } from "./SavePresetButton.vue?vue&type=template&id=0ea26f2c"
import script from "./SavePresetButton.vue?vue&type=script&lang=js"
export * from "./SavePresetButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports